import { styled } from '@/stitches.config';

import { ReactComponent as ArrowIcon } from '@assets/icons/simple-arrow.svg';

export const PaginationContainerStyled = styled('ul', {
  display: 'flex',
  listStyleType: 'none',
  px: '$0',
});

export const PaginationItemStyled = styled('li', {
  $$pageNumberHover: '$colors$darkBlue800',
  $$arrow: '$colors$darkGray200',

  alignItems: 'center',
  borderRadius: '$round',
  boxSizing: 'border-box',
  display: 'flex',
  height: '$8',
  justifyContent: 'center',
  minWidth: '$8',
  my: 'auto',
  textAlign: 'center',

  '&:hover': {
    backgroundColor: '$$pageNumberHover',
    cursor: 'pointer',
  },

  variants: {
    disabled: {
      true: {
        pointerEvents: 'none',
      },
    },
    dots: {
      true: {
        '&:hover': {
          backgroundColor: 'transparent',
          cursor: 'default',
        },
      },
    },
    selected: {
      true: {
        mx: '$1',
        border: '$borderWidths$2 solid $blue300',
        color: '$blue300',
        '&:hover': {
          backgroundColor: 'transparent',
        },
        fontWeight: '$medium',
      },
    },
  },
});

export const ArrowIconStyled = styled(ArrowIcon, {
  color: '$$arrow',
  variants: {
    variant: {
      right: {
        rotate: '180deg',
      },
    },
  },
});
